import { Env } from '../../../env';
import { ApiClient } from '../../../http/api_client';
import { ArrivalContactReceptionJsEnv } from '../../../models/currentsystem/club/arrival_contact_reception_js_env';

export class ArrivalContactReceptionRepository {
    async callArrivalContactReception(catalogItemCode: String): Promise<ArrivalContactReceptionJsEnv> {
        let result: any
        try {
          result = await ApiClient.get(
            `${Env.SETTING.userPublicApi.urlBase}ctg/apiArrivalCallReception/?ctgItemCd=${catalogItemCode}`,
            {responseType: 'document'} // 現行APIのレスポンスはXMLのためdocumentで受け取る
          );
        } catch(err) {
          result = err.response.data
        }

        // レスポンス例：
        // <response>
        //   <code>00000</code>
        //   <message>OK</message>
        // </response>
        return new ArrivalContactReceptionJsEnv(
          result.getElementsByTagName('code')[0]?.textContent,
          result.getElementsByTagName('message')[0]?.textContent
        )
    }
}
